import produce from "immer";
import { Action } from "redux";
import { ErrorState, ErrorPayload, RESET_ERROR_MESSAGE } from "./types";

const initialState: ErrorState = {};

const errorReducer = produce(
  (draft: ErrorState, action: Action<string> & ErrorPayload) => {
    const matches = /.*_(REQUEST|FAILURE)/.exec(action.type);

    if (matches) {
      const requestName = action.type.replace(/_FAILURE/, "_REQUEST");
      const [, requestState] = matches;

      requestState === "FAILURE"
        ? draft[requestName] = action.errorMessage
        : delete draft[requestName];
    } else if (action.type === RESET_ERROR_MESSAGE) {
      Object.keys(draft).forEach(key => delete draft[key]);
    } else {
      return draft;
    }
  },
  initialState
);

export default errorReducer;
